import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74c658d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "flex align-items-center" }

import { computed, ref } from 'vue';
import { signedPercentFormat } from '@/utils/format';
import { documentStyles } from '@/composables/charts/useCharts';


export default /*#__PURE__*/_defineComponent({
  __name: 'LpTokenPriceChart',
  props: {
    prices: null
  },
  setup(__props: any) {

const props = __props as {
  prices: number[];
}



/**
 * NOTE:
 * Calculate Percentage Change
 *
 * DIFF = <New Number> - <Original Number>
 * <Percentage Change> = DIFF ÷ <Original Number> × 100
 */
const priceChangePercent = computed(
  () => ((props.prices[props.prices.length - 1] - props.prices[0]) / props.prices[0]) * 100,
);
const isPriceUp = computed(() => priceChangePercent.value >= 0);
const priceMax = computed(() => Math.max(...props.prices));
const chartColor = computed(() => (isPriceUp.value ? 'success' : 'error'));
const chartData = ref({
  labels: new Array(props.prices.length).fill(''),
  datasets: [
    {
      data: props.prices,
      yAxisID: 'yAxis',
      fill: true,
      tension: 0.4,
      borderColor: documentStyles.value.getPropertyValue(`--${chartColor.value}`),
      backgroundColor: documentStyles.value.getPropertyValue(`--${chartColor.value}-10`),
    },
  ],
});
const chartOptions = ref({
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  elements: {
    point: {
      radius: 1,
      borderWidth: 0,
      hoverRadius: 1,
    },
    line: {
      borderWidth: 2,
    },
  },
  scales: {
    yAxis: {
      display: false,
      min: 0,
      max: priceMax.value + 0.1 * priceMax.value,
    },
    xAxis: {
      display: false,
    },
  },
  layout: {
    padding: 1,
  },
  maintainAspectRatio: false,
});

return (_ctx: any,_cache: any) => {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Chart, {
        type: "line",
        data: chartData.value,
        options: chartOptions.value,
        class: "chart-line"
      }, null, 8, ["data", "options"]),
      _createElementVNode("div", {
        class: _normalizeClass(`text-${_unref(chartColor)} ml-s3`)
      }, _toDisplayString(_unref(signedPercentFormat)(_unref(priceChangePercent))), 3)
    ])
  ]))
}
}

})